import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50b7681a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fgc-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "page-title" }, "BGG FGC"),
  /*#__PURE__*/_createElementVNode("p", { class: "page-sub" }, "Fighting Game Community"),
  /*#__PURE__*/_createElementVNode("div", { class: "title-rule" })
], -1))
const _hoisted_3 = { class: "event-game" }
const _hoisted_4 = { class: "event-row" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "card-icon-wrap reg-icon" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "Tournament Registration", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-name" }, "Register on start.gg", -1))
const _hoisted_10 = { class: "card-sub" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "card-icon-wrap pool-icon" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-label" }, "Prize Pool", -1))
const _hoisted_15 = { class: "card-name" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-sub" }, "Donate via PayPal", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
      return (_openBlock(), _createElementBlock("div", {
        key: event.game,
        class: "event-section"
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(event.game), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "fgc-card card-reg",
            onClick: ($event: any) => (_ctx.openRegistration(event.registrationUrl))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_v_icon, {
                size: "22",
                color: "#00e5ff"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-controller")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, _toDisplayString(event.registrationUrl), 1)
            ]),
            _createVNode(_component_v_icon, {
              class: "card-arrow",
              size: "16"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-arrow-top-right")
              ]),
              _: 1
            })
          ], 8, _hoisted_5),
          _createElementVNode("div", {
            class: "fgc-card card-pool",
            onClick: ($event: any) => (_ctx.$router.push(event.prizePoolRoute))
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_v_icon, {
                size: "22",
                color: "#ff9800"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-trophy-outline")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(event.game) + " Prize Pool", 1),
              _hoisted_16
            ]),
            _createVNode(_component_v_icon, {
              class: "card-arrow",
              size: "16"
            }, {
              default: _withCtx(() => [
                _createTextVNode("mdi-chevron-right")
              ]),
              _: 1
            })
          ], 8, _hoisted_11)
        ])
      ]))
    }), 128))
  ]))
}